import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { DefaultModal } from '@libs/ui/components/modals';

interface SuccessInviteModalProps {
  open: boolean;
  handleClose: VoidFunction;
}

const SuccessInviteModal = ({
  open,
  handleClose,
}: SuccessInviteModalProps) => {
  const { t } = useTranslation('talentMatcher');
  return (
    <DefaultModal
    open={open}
    handleClose={handleClose}
    title={t('inviteSuccess.title')}
  >
    <Box maxWidth="290px">
      <Grid spacing={4} direction="column" container>
        <Grid item>{t('inviteSuccess.body')}</Grid>
      </Grid>
    </Box>
  </DefaultModal>
  );
};

export default SuccessInviteModal;
